import { Component } from "react";
import "./ConfirmationDialog.css";
import PropTypes from "prop-types";
import Dialog from "./../../Dialog";
import Action from "./../../../../../formElements/Action/Action";

/**
 * The confirmation dialog that is used for different simple confirmation messages like the ones that
 * we show before deletion.
 */
export default class ConfirmationDialog extends Component {
  render() {
    let actions = this.props.actions.map(function (action, index) {
      return (
        <Action key={index} onClick={action.handler} data-cy={action.dataCy}>
          {action.name}
        </Action>
      );
    });

    return (
      <Dialog
        dataCy={this.props.dataCy}
        className={
          this.props.className ? this.props.className + " confirmation" : "confirmation"
        }
        showDialog={this.props.showDialog}
        closeOnOuterClick={this.props.closeOnOuterClick}
        onClose={this.props.onClose}
      >
        <h2>{this.props.title}</h2>
        <div className="inner">{this.props.children}</div>
        <div className="actions">{actions}</div>
      </Dialog>
    );
  }
}

ConfirmationDialog.propTypes = {
  /** Boolean value that defines whether to show dialog or not. */
  showDialog: PropTypes.bool.isRequired,
  /** A custom CSS class name that can be added to the dialog's default list of classes. */
  className: PropTypes.string,
  /** Function/callback that invokes when dialog is being closed. */
  onClose: PropTypes.func.isRequired,
  /** "Identificator" to use in cypress tests. */
  dataCy: PropTypes.string,
  /** A string title of the dialog. */
  title: PropTypes.string,
  /** Actions to show in confirmation dialog. */
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      /** Action's name. */
      name: PropTypes.string,
      /** "Identificator" to use in cypress tests. */
      dataCy: PropTypes.string,
      /** Action's handler. */
      handler: PropTypes.func,
    })
  ).isRequired,
};
